import { RouteRecordRaw } from 'vue-router';

function ecclepRoutesResolver(layout: string) : RouteRecordRaw[] {
  return [
    {
      meta:
      {        
        description: 'Oficjalna strona internetowa parafii, najważniejsze informacje parafialne, strona główna'
      },
      path: '/',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Home/Home.vue') }],
    },
    {
      meta:
      {
        title: 'Intencje i nabożeństwa',
        description: 'Intencje mszalne i nabożeństwa odprawiane w poszczególnych tygodniach'
      },
      path: '/intencje-i-nabozenstwa',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Intentions/Intentions.vue') }],
    },    
    {
      meta:
      {
        title: 'Intencje i nabożeństwa - wydruk',
        description: 'Wydruk intenci i nabożeństw na bieżący tydzień '
      },
      path: '/intencje-i-nabozenstwa-wydruk/:churchId',
      component: () => import('layouts/PrintLayout.vue'),
      children: [{ path: '', component: () => import('pages/Intentions/IntentionsPrint.vue') }],
    },
    {
      meta:
      {
        title: 'Obecności na nabożeństwach',
        description: 'Obecności na nabożeństwach dzieci przystępujących do pierwszej komunii i bierzmowania'
      },
      path: '/obecnosci-na-nabozenstwach',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/ServiceAttendance/ServiceAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Skanowanie obecności na nabożeństwach',
        description: 'Skanowanie obecności na nabożeństwach dzieci przystępujących do pierwszej komunii i bierzmowania'
      },
      path: '/skanowanie-obecnosci/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/ServiceAttendance/ScanAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Skanowanie obecności na nabożeństwach',
        description: 'Skanowanie obecności na katechezach dzieci przystępujących do pierwszej komunii i bierzmowania'
      },
      path: '/skanowanie-obecnosci-na-katechezie/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CatechesisAttendance/ScanAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Wydarzenia i galerie',
        description: 'Lista wydarzeń parafialnych, uroczytości, świąt wraz z opcjonalnymi galeriami zdjęć'
      },
      path: '/wydarzenia-i-galerie',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Events/EventsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Wydarzenia i galerie',
        description: 'Wydarzenie parafialne wraz z opcjonalną galerią zdjęć'
      },
      path: '/wydarzenia-i-galerie/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Events/EventsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Pielgrzymki',
        description: 'Lista pielgrzymek parafialnych wraz z opcjonalnymi galeriami zdjęć'
      },
      path: '/pielgrzymki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pilgrimages/PilgrimagesList.vue') }],
    },    
    {
      meta:
      {
        title: 'Pielgrzymki',
        description: 'Pielgrzymka parafialna wraz z opcjonalną galerią zdjęć'
      },
      path: '/pielgrzymki/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pilgrimages/PilgrimagesDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Budowa i remonty',
        description: 'Ewidencja prac remontowo budowlanych realizowanych w parafii wraz z opcjonalnymi zdjęciami'
      },
      path: '/budowa-i-remonty',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Renovations/RenovationsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Budowa i remonty',
        description: 'Opis pojedynczego etapu prac remontowo budowlanych w parafii wraz z opcjonalnymi zdjęciami'
      },
      path: '/budowa-i-remonty/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Renovations/RenovationsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Proboszczowie',
        description: 'Lista księży sprawujących urząd proboszcza w parafii, informacje nt. obecnego proboszcza oraz proboszczów pracujących w poprzednich latach'
      },
      path: '/proboszczowie',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Rectors/RectorsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Proboszczowie',
        description: 'Informacje nt. proboszcza (bieżącego lub poprzedniego), informacje nt. kapłaństwa, biografia'
      },
      path: '/proboszczowie/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Rectors/RectorsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Wikariusze',
        description: 'Lista księży sprawujących urząd wikariusza w parafii, informacje nt. obecnych wikariuszy oraz wikariuszy pracujących w poprzednich latach'
      },
      path: '/wikariusze',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Vicars/VicarsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Wikariusze',
        description: 'Informacje nt. wikariusza (bieżącego lub poprzedniego), informacje nt. kapłaństwa, biografia'
      },
      path: '/wikariusze/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Vicars/VicarsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Rezydenci',
        description: 'Lista księży sprawujących urząd rezydenta w parafii, informacje nt. obecnych rezydentów oraz rezydentów pracujących w poprzednich latach'
      },
      path: '/rezydenci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Residents/ResidentsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Rezydenci',
        description: 'Informacje nt. rezydenta (bieżącego lub poprzedniego), informacje nt. kapłaństwa, biografia'
      },
      path: '/rezydenci/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Residents/ResidentsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Siostry zakonne',
        description: 'Lista sióstr zakonnych pracujących na terenie parafii, informacje nt. obecnych sióstr zakonnych oraz sióstr pracujących w poprzednich latach'
      },
      path: '/siostry-zakonne',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Sisters/SistersList.vue') }],
    },    
    {
      meta:
      {
        title: 'Siostry zakonne',
        description: 'Informacje nt. siostry zakonnej (obecnej lub poprzedniej), informacje nt. zakonu, biografia'
      },
      path: '/siostry-zakonne/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/Sisters/SistersDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Pochodzący kapłani',
        description: 'Lista kapłanów pochodzących z parafii'
      },
      path: '/pochodzacy-kaplani',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/NativePriests/NativePriestsList.vue') }],
    },    
    {
      meta:
      {
        title: 'Pochodzący kapłani',
        description: 'Informacje nt. kapłana pochodzącego z parafii, informacje nt. kapłaństwa, biografia'
      },
      path: '/pochodzacy-kaplani/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/NativePriests/NativePriestsDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'Pochodzące siostry',
        description: 'Lista sióstr zakonnych pochodzących z parafii'
      },
      path: '/pochodzace-siostry',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/NativeSisters/NativeSistersList.vue') }],
    },    
    {
      meta:
      {
        title: 'Pochodzące siostry',
        description: 'Informacje nt. siostry zakonnej pochodzącej z parafii, informacje nt. zakonu, biografia'
      },
      path: '/pochodzace-siostry/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Pastors/NativeSisters/NativeSistersDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'O stronie',
        description: 'Informacje nt. powstania strony parafialnej, kto dostarczył szablon strony parafialnej, kto jest opiekunem, historia powstania strony'
      },
      path: '/o-stronie',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/About/About.vue') }],
    },   
    {
      meta:
      {
        title: 'Ciekawe linki',
        description: 'Lista linków do ważnych, zaprzyjaźnionych stron internetowych np. sąsiednich parafii, diecezji'
      },
      path: '/ciekawe-linki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Links/Links.vue') }],
    },    
    {
      meta:
      {
        title: 'Kontakt',
        description: 'Informacje kontaktowe parafii, adres, numery telefonów, mail, konto bankowe, przynależność do diecezji i dekanatu'
      },
      path: '/kontakt',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Contact/Contact.vue') }],
    },    
    {
      meta:
      {
        title: 'Ogłoszenia',
        description: 'Ogłoszenia parafialne na bieżący tydzień, informacje o zapowiedziach przedślubnych'
      },
      path: '/ogloszenia',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Announcemens/Announcements.vue') }],
    },
    {
      meta:
      {
        title: 'Ogłoszenia - wydruk',
        description: 'Wydruk ogłoszeń parafialne na bieżący tydzień oraz informacji o zapowiedziach przedślubnych'
      },
      path: '/ogloszenia-wydruk',
      component: () => import('layouts/PrintLayout.vue'),
      children: [{ path: '', component: () => import('pages/Announcemens/AnnouncementsPrint.vue') }],
    },
    {
      meta:
      {
        title: 'Ogłoszenia - wydruk',
        description: 'Wydruk ogłoszeń parafialne na bieżący tydzień oraz informacji o zapowiedziach przedślubnych (w kontekście wybranego kościołą)'
      },
      path: '/ogloszenia-wydruk/:churchId',
      component: () => import('layouts/PrintLayout.vue'),
      children: [{ path: '', component: () => import('pages/Announcemens/AnnouncementsPrint.vue') }],
    },
    {
      meta:
      {
        title: 'Na żywo',
        description: 'Informacje nt. prowadzonych transmisji na żywo (nabożeństwa, msze), terminy, linki do podglądu z kamery'
      },
      path: '/na-zywo',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/LiveStreaming/LiveStreaming.vue') }],
    },   
    {
      meta:
      {
        title: 'e-taca',
        description: 'Składanie tygodniowej ofiary (tacy parafialnej) za pomocą płatności online'
      },
      path: '/e-taca',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/DonationDefinition/WeeklyDonationDetails.vue') }],
    },    
    {
      meta:
      {
        title: 'e-ofiara',
        description: 'Składanie ofiary za intencje mszalne za pomocą płatności online'
      },
      path: '/e-ofiara',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/DonationDefinition/IntentionDonationDetails.vue') }],
    },
    {
      meta:
      {
        title: 'Miejsce na Twoją reklamę',
        description: 'Miejsce na Twoją reklamę (sponsoring)'
      },
      path: '/sponsor',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Sponsor/Sponsor.vue') }],
    },
    {
      meta:
      {
        title: 'Obszar i statystyka',
        description: 'Informacje statystyczne nt. parafii, liczba parafian, data powstania parafii, kościoły, miejscowości, szkoły przynależne do parafii'
      },
      path: '/obszar-i-statystyka',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Statistics/Statistics.vue') }],    
    },    
    {
      meta:
      {
        title: 'Zdjęcia parafii',
        description: 'Galeria zdjęć prezentująca wizerunek parafii (kościoły, plebania i inne obiekty religijne na terenie parafii'
      },
      path: '/zdjecia-parafii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/ParishImages/ParishImages.vue') }],
    },    
    {
      meta: {
        title: 'Liturgia dnia',
        description: 'Czytania, psalm, aklamacja, ewangelia na dany dzień'
      },
      path: '/liturgia-dnia',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Liturgy/Liturgy.vue') }],
    },   
    {
      meta:
      {
        title: 'Historia parafii',
        description: 'Historia powstania parafii oraz przynależnych kościołów'
      },
      path: '/historia-parafii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/History/History.vue') }],
    },   
    {
      meta:
      {
        title: 'Nagrania',
        description: 'Pliki mp3 z nagraniami homilii, innych wydarzeń parafialnych'
      },
      path: '/nagrania',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Recordings/Recordings.vue') }],
    },    
    {
      meta:
      {
        title: 'Zmarli',
        description: 'Informacje nt. zmarłych parafian w podziale na poszczególne lata'
      },
      path: '/zmarli',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Deads/DeadsList.vue') }],
    },
    {
      meta:
      {
        title: 'Wyszukiwarka zmarłych',
        description: 'Wyszukiwarka zmarłych osób'
      },
      path: '/wyszukiwarka-zmarlych',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Deads/DeadSearch.vue') }],
    },
    {
      meta:
      {
        title: 'Zmarli',
        description: 'Informacje nt. zmarłego parafianina (data, miejsce zamieszkania opcjonalnie miejsce pochówku, cmentarz)'
      },
      path: '/zmarli/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Deads/DeadsDetails.vue') }],
    },
    {
      meta:
      {
        title: 'Intencje pogrzebowe zmarłych',
        description: 'Lista intencji mszalnych za zmarłe osoby wraz opcjonalnie z datami odprawiania tych intencji'
      },
      path: '/intencje-pogrzebowe',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/DeadsIntentions/DeadIntention.vue') }],
    },
    {
      meta:
      {
        title: 'Rocznice zmarłych',
        description: 'Rocznice urodzin i śmierci zmarłych parafian'
      },
      path: '/rocznice',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/DeadAniversary/DeadAniversary.vue') }],
    },
    {
      meta:
      {
        title: 'Mapa cmentarza',
        description: 'Interaktywna mapa cmentarza wraz z wizualizacja grobów'
      },
      path: '/mapa-cmentarza',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CemeteryMap/CemeteryMap.vue') }],
    },
    {
      meta:
      {
        title: 'Mapa cmentarza',
        description: 'Interaktywna mapa cmentarza wraz z wizualizacja grobów'
      },
      path: '/mapa-cmentarza/groby/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CemeteryMap/CemeteryMap.vue') }],
    },
    {
      meta:
      {
        title: 'Groby',
        description: 'Ewidencja grobów w podziale na sektory, rzędy i numery'
      },
      path: '/groby',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Graves/GravesList.vue') }],
    },
    {
      meta:
      {
        title: 'Grób',
        description: 'Informacje nt. grobu (sektor, rząd, number) oraz pochowanych w nim zmarłych osób'
      },
      path: '/groby/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Graves/GravesDetails.vue') }],
    },
    {
      meta:
      {
        title: 'Chrzty',
        description: 'Informacje nt. ochrzczonych parafian w podziale na poszczególne lata'
      },
      path: '/chrzty',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Baptisms/Baptisms.vue') }],
    },
    {
      meta:
      {
        title: 'Śluby',
        description: 'Informacje nt. udzielonych sakramentów ślubu dla osób pochodzących z parafii w podziale na poszczególne lata'
      },
      path: '/sluby',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{
        path: '', component: () => import('pages/Weddings/Weddings.vue') }],
    },
    {
      meta:
      {
        title: 'Uroczystości',
        description: 'Kalendarz świąt i uroczystości parafialnych przeszłych i przyszłych (np. informacje nt. daty I komunii św., bierzmowania, dożynek itp.)'
      },
      path: '/uroczystosci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Celebrations/Celebrations.vue') }],
    },
    {
      meta:
      {
        title: 'Historyczne daty',
        description: 'Chronologiczny wykaz ważnych dat - wydarzeń parafialnych'
      },
      path: '/historyczne-daty',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/HistoricalDates/HistoricalDates.vue') }],
    },   
    {
      meta:
      {
        title: 'ECCLEP Wizytówka',
        description: 'Wizytówka systemu ECCLEP, na podstawie którego stworzona jest strona parafialna'
      },
      path: '/ecclep-wizytowka',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/BusinessCard/BusinessCard.vue') }],
    },    
    {
      meta:
      {
        title: 'Polityka Cookies',
        description: 'Polityka cookies określająca zasady przechowywania i dostępu do danych na urządzeniach użytkowników'
      },
      path: '/polityka-cookies',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CookiesPolicy/CookiesPolicy.vue') }],
    },  
    {
      meta:
      {
        title: 'Rada parafialna',
        description: 'Informacje nt. składu i działalności rady parafialnej'
      },
      path: '/rada-parafialna',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Council/Council.vue') }],
    },    
    {
      meta:
      {
        title: 'Ministranci',
        description: 'Informacje nt. grupy ministrantów w parafii, lista ministrantów, zakres obowiązków itp.'
      },
      path: '/ministranci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Acolytes/Acolytes.vue') }],
    },
    {
      meta:
      {
        title: 'Obecność ministrantów na nabożeństwach',
        description: 'Obecność ministrantów na nabożeństwach'
      },
      path: '/ministranci-obecnosc',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/AcolytesAttendance/AcolytesAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Dyżury służby liturgicznej',
        description: 'Dyżury liturgicznej służby ołtarza'
      },
      path: '/dyzury-sluzby-liturgicznej',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/MinistrySchedule/MinistrySchedule.vue') }],
    },
    {
      meta:
      {
        title: 'Róże różańcowe',
        description: 'Lista róż różańcowych stworzonych na terenie parafii, informacje nt. ich aktywności, terminy spotkań, składy osobowe itp.'
      },
      path: '/roze-rozancowe',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/RoseRosary/RoseRosary.vue') }],
    }, 
    {
      meta:
      {
        title: 'Koronawirus',
        description: 'Informacje dotyczące wszelakich ograniczeń związanych z wirusem COVID, ograniczenia, zalecenia itp.'
      },
      path: '/koronawirus',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'koronawirus', picture: 'Koronawirus.jpg' } }],
    },
    {
      meta:
      {
        title: 'List duszpasterski',
        description: 'Treść listów duszpasterskich przesyłanych z diecezji, dekanatu lub episkopatu'
      },
      path: '/list-duszpasterski',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'PastoralLetter', picture: 'PastoralLetter.jpg' } }],
    },
    {
      meta:
      {
        title: 'Rekolekcje adwentowe',
        description: 'Informacje nt. prowadzonych rekolekcji adwentowych w parafii, prowadzący kapłan, terminy mszy św., dedykowanych nauk itp.'
      },
      path: '/rekolekcje-adwentowe',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'AdventRetreat', picture: 'rekolekcje-adwentowe.jpg' } }],
    },
    {
      meta:
      {
        title: 'Wizyta duszpasterska',
        description: 'Plan kolędy (wizyty duszpasterskiej)'
      },
      path: '/koleda',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Carols/Carols.vue') }],
    },
    {
      meta:
      {
        title: 'Rekolekcje wielkopostne',
        description: 'Informacje nt. prowadzonych rekolekcji wielkopostnych w parafii, prowadzący kapłan, terminy mszy św., dedykowanych nauk itp.'
      },
      path: '/rekolekcje-wielkopostne',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LentenRetreat', picture: 'rekolekcje-wielkopostne.jpg' } }],
    },
    {
      meta:
      {
        title: 'Biuletyn',
        description: 'Wersja elektroniczna biuletynu, listu parafialnego wydawanego dla społeczności parafialnej'
      },
      path: '/biuletyn',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Bulletin', picture: 'biuletyn.jpg' } }],
    },
    {
      meta:
      {
        title: 'Wypominki',
        description: 'Wypominki za zmarłe osoby (jednorazowe, okresowe,  roczne)'
      },
      path: '/wypominki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DeadPrayers', picture: 'DeadPrayers.jpg' } }],
    },
    {
      meta:
      {
        title: 'e-Wypominki',
        description: 'Wypominki za zmarłe osoby (jednorazowe, okresowe,  roczne) składane drogą elektroniczną'
      },
      path: '/e-wypominki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/DonationDefinition/DeadPrayersDonationDetails.vue') }],
    },
    {
      meta:
      {
        title: 'Patron parafii',
        description: 'Informacje nt. patrona parafii, biografia, ciekawe informacje z życia'
      },
      path: '/patron-parafii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Patron' } }],
    },
    {
      meta:
      {
        title: 'Krzyże i kapliczki',
        description: 'Informacje nt. przydrożnych krzyży i kapliczek jakie znajdują się na terenie parafii'
      },
      path: '/krzyze-i-kapliczki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'CrossChapel' } }],
    },
    {
      meta:
      {
        title: 'Cmentarz',
        description: 'Ogólne informacje o cmentarzu, regulamin'
      },
      path: '/cmentarz',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Cemetery', picture: 'Cemetery.jpg' } }],
    },    
    {
      meta:
      {
        title: 'Caritas',
        description: 'Informacje nt. działalności parafialnego zespołu Caritas'
      },
      path: '/caritas',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Caritas', picture: 'Caritas.jpg' } }],
    },
    {
      meta:
      {
        title: 'Ogłoszenia',
        description: 'Ogłoszenia parafialne dotyczące dzieci przystępujących do I Komunii Świętej'
      },
      path: '/komunia-ogloszenia',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'HolyCommunionAnnouncements', picture: 'HolyComunionAnnouncements.jpg' } }],
    },
    {
      meta:
      {
        title: 'Uczestnicy',
        description: 'Lista dzieci przystępujących do I Komunii Świętej w podziale na lata'
      },
      path: '/komunia-uczestnicy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/FirstHolyCommunion/FirstHolyCommunion.vue') }],
    },
    {
      meta:
      {
        title: 'Obecność kandydatów do I Komunii na nabożeństwach',
        description: 'Obecność kandydatów do I Komunii na nabożeństwach'
      },
      path: '/komunia-obecnosc-kandydatow',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/FirstHolyCommunionAttendance/FirstHolyCommunionAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Porady',
        description: 'Porady dot. sakramentu I Komunii Świętej'
      },
      path: '/komunia-porady',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'FirstHolyCommunionAdvice', picture: 'komunia-porady.jpg' } }],
    },
    {
      meta:
      {
        title: 'Ogłoszenia',
        description: 'Ogłoszenia parafialne dotyczące dzieci przystępujących do sakramentu bierzmowania'
      },
      path: '/bierzmowanie-ogloszenia',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ConfirmationAnnouncements', picture: 'bierzmowanie-ogloszenia.jpg' } }],
    },
    {
      meta:
      {
        title: 'Uczestnicy',
        description: 'Lista dzieci przystępujących do sakramentu bierzmowania w podziale na lata'
      },
      path: '/bierzmowanie-uczestnicy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Confirmation/Confirmation.vue') }],
    },
    {
      meta:
      {
        title: 'Obecność kandydatów do bierzmowania na nabożeństwach',
        description: 'Obecność kandydatów do bierzmowania na nabożeństwach'
      },
      path: '/bierzmowanie-obecnosc-kandydatow',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/ConfirmationAttendance/ConfirmationAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Porady',
        description: 'Porady dot. sakramentu bierzmowania'
      },
      path: '/bierzmowanie-porady',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ConfirmationAdvice', picture: 'bierzmowanie-porady.jpg' } }],
    },
    {
      meta:
      {
        title: 'Lektorzy',
        description: 'Informacje nt. grupy lektorów w parafii, lista lektorów, zakres obowiązków itp.'
      },
      path: '/lektorzy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Lectors', picture: 'Lectors.jpg' } }],
    },
    {
      meta:
      {
        title: 'Chór parafialny',
        description: 'Informacje nt. działalności chóru parafialnego, terminy spotkań, skład itp.'
      },
      path: '/chor-parafialny',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'choir', picture: 'Choir.jpg' } }],
    },
    {
      meta:
      {
        title: 'Schola liturgiczna',
        description: 'Informacje nt. działalności scholi liturgicznej działającej na terenie parafii, terminy spotkań, skład itp.'
      },
      path: '/schola-liturgiczna',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LiturgicalChoir', picture: 'LiturgicalChoir.jpg' } }],
    },
    {
      meta:
      {
        title: 'Orkiestra dęta',
        description: 'Informacje nt. działalności parafialnej orkiestry dętej'
      },
      path: '/orkiestra-deta',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Brass', picture: 'Brass.jpg' } }],
    },
    {
      meta:
      {
        title: 'Młodzież',
        description: 'Informacje nt. działalności młodzieżowych grup parafialnych działających na terenie parafii, terminy spotkań, skład itp.'
      },
      path: '/mlodziez',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Youth', picture: 'Youth.jpg' } }],
    },
    {
      meta:
      {
        title: 'KSM',
        description: 'Grupa parafialna Katolickie Stowarzyszenie Młodzieży działająca na terenie parafii, terminy spotkań, skład itp.'
      },
      path: '/katolickie-stowarzyszenie-mlodzierzy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KSM', picture: 'katolickie-stowarzyszenie-mlodzierzy.jpg' } }],
    },
    {
      meta:
      {
        title: 'Dziewczęca służba Maryjna',
        description: 'Grupa parafialna Dziewczęca służba Maryjna działająca na terenie parafii, terminy spotkań, skład itp.'
      },
      path: '/dziewczeca-sluzba-maryjna',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DSM' } }],
    },
    {
      meta:
      {
        title: 'Odnowa w Duchu Św.',
        description: 'Grupa parafialna Odnowa w Duchu Św. działająca w parafii, terminy spotkań, skład itp.'
      },
      path: '/odnowa-w-duchu-swietym',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'OdnowaWDuchuSwietym', picture: 'odnowa-w-duchu-sw.jpg' } }],
    },
    {
      meta:
      {
        title: 'Szafarze komunii',
        description: 'Informacje nt. grupy szafarzy komunii świętej, obowiązki, lista osób'
      },
      path: '/szafarze-komunii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Ministers', picture: 'Ministers.jpg' } }],
    },
    {
      meta:
      {
        title: 'Kościelny',
        description: 'Informacje nt. kościelnego (zakrystianina) pracującego na terenie parafii, obowiązki'
      },
      path: '/koscielny',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Ecclesiastical', picture: 'Ecclesiastical.jpg' } }],
    },
    {
      meta:
      {
        title: 'Organista',
        description: 'Informacje nt. organisty pracującego na terenie parafii'
      },
      path: '/organista',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Organists', picture: 'Organists.jpg' } }],
    },
    {
      meta:
      {
        title: 'Katecheci',
        description: 'Informacje nt. katechetów pracujących w parafii'
      },
      path: '/katecheci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Catechists', picture: 'Catechists.jpg' } }],
    },    
    {
      meta:
      {
        title: 'Chrzest',
        description: 'Porady dot. sakramentu chrztu św.'
      },
      path: '/chrzest-porady',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'BaptismsAdvice', picture: 'Baptism.jpg' } }],
    },
    {
      meta:
      {
        title: 'Pokuta',
        description: 'Porady dot. sakramentu pokuty (spowiedzi)'
      },
      path: '/pokuta',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Penance', picture: 'Penance.jpg' } }],
    },
    {
      meta:
      {
        title: 'Namaszczenie chorych',
        description: 'Porady dot. sakramentu namaszczenia chorych'
      },
      path: '/namaszczenie-chorych',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'SickAnointing', picture: 'SickAnointing.jpg' } }],
    },
    {
      meta:
      {
        title: 'Małżeństwo',
        description: 'Porady dot. sakramentu małżeństwa'
      },
      path: '/malzenstwo',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Marriage', picture: 'Marriage.jpg' } }],
    },
    {
      meta:
      {
        title: 'Pogrzeb',
        description: 'Porady dot. pogrzebu chrześcijańskiego'
      },
      path: '/pogrzeb',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'Funeral', picture: 'Funeral.jpg' } }],
    },    
    {
      meta:
      {
        title: 'Modlitwy błagalne',
        description: 'Lista modlitw błagalnych w różnych intencjach'
      },
      path: '/modlitwy-blagalne',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'PrayerRequest', picture: 'PrayerRequest.jpg' } }],
    },
    {
      meta:
      {
        title: 'Modlitwy różne',
        description: 'Lista różnych modlitw w różnych intencjach'
      },
      path: '/modlitwy-rozne',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'PrayerOthers', picture: 'PrayerOthers.jpg' } }],
    },
    {
      meta:
      {
        title: 'Modlitwy rodzinne',
        description: 'Lista modlitw rodzinnych w różnych intencjach'
      },
      path: '/modlitwy-rodzinne',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'PrayerFamily', picture: 'PrayerFamily.jpg' } }],
    },
    {
      meta:
      {
        title: 'Ochrona danych',
        description: 'Informacje nt. ochrony danych osobowych w parafii (RODO)'
      },
      path: '/ochrona-danych',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'GDPR', picture: 'GDPR.jpg' } }],
    },
    {
      meta:
      {
        title: 'Standardy ochrony dzieci',
        description: 'Standardy ochrony dzieci w parafii'
      },
      path: '/ochrona-dzieci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ChildProtection', picture: 'ChildProtection.jpg' } }],
    },
    {
      meta:
      {
        title: 'Domowy kościół',
        description: 'Domowy kościół w parafii'
      },
      path: '/domowy-kosciol',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KobylkaDomowyKosciol'} }],
    },
    {
      meta:
      {
        title: 'Żubardzkie wieści',
        description: 'Żubardzkie wieści - parafia'
      },
      path: '/zubardzkie-wiesci',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LodzOdkupicielaZubardzieWiesci' } }],
    },
    {
      meta:
      {
        title: 'KSM',
        description: 'Grupa parafialna Katolickie Stowarzyszenie Młodzieży działająca na terenie parafii, terminy spotkań, skład itp.'        
      },
      path: '/ksm-rzuchowa',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'RzuchowaKSM' } }],
    },
    {
      meta:
      {
        title: 'Pozostałe grupy',
        description: 'Pozostałe grupy parafialne'
      },
      path: '/polczyn-pozostale-grupy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'PolczynPozostaleGrupy' } }],
    },
    {
      meta:
      {
        title: 'Akcja katolicka',
        description: 'Akcja katolicka'
      },
      path: '/weglowka-akcja-katolicka',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'WeglowkaAkcjaKatolicka' } }],
    },
    {
      meta:
      {
        title: 'Dziekani parafii',
        description: 'Dziekani parafii'
      },
      path: '/lakta-dziekani-parafii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LaktaDziekaniParafii' } }],
    },
    {
      meta:
      {
        title: 'Mali rycerze',
        description: 'Mali Rycerze Miłosiernego Serca Jezusowego'
      },
      path: '/lakta-mali-rycerze',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LaktaMaliRycerze' } }],
    },
    {
      meta:
      {
        title: 'Pozostałe grupy',
        description: 'Pozostałe grupy parafialne'
      },
      path: '/debica-pozostale-grupy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DebicaPozostaleGrupy' } }],
    },
    {
      meta:
      {
        title: 'Rycerstwo Niepokalanej',
        description: 'Rycerstwo Niepokalanej'
      },
      path: '/kamiensk-rycerstwo-niepokalanej',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KamienskRycerstwoNiepokalanej' } }],
    },
    {
      meta:
      {
        title: 'Nowenna MBNP',
        description: 'Nowenna do Matki Bożej Nieustającej Pomocy'
      },
      path: '/cieplie-nowenna-mbnp',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'CiepliceNowennaMBNP' } }],
    },
    {
      meta:
      {
        title: 'Św. Rita',
        description: 'Św. Rita - współpatronka Parafii, Peregrynacja Obrazu'
      },
      path: '/cieplie-sw-rita',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'CieplicSwRita' } }],
    },
    {
      meta:
      {
        title: 'Wieczysta adoracja',
        description: 'Wieczysta adoracja - Eucharystyczna Straż Honorowa'
      },
      path: '/malec-wieczysta-adoracja',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'MalecWieczystaAdoracja' } }],
    },
    {
      meta:
      {
        title: 'Rodziny MB z Szensztatu',
        description: 'Apostolat Pielgrzymującej Matki Bożej z Szensztatu'
      },
      path: '/malec-rodziny-mb-z-szensztatu',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'MalecMBZSzensztatu' } }],
    },
    {
      meta:
      {
        title: 'LSO',
        description: 'Liturgiczna służba ołtarza'
      },
      path: '/debica-LSO',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DebicaLSO' } }],
    },
    {
      meta:
      {
        title: 'Wieczysta adoracja',
        description: 'Wieczysta adoracja'
      },
      path: '/debica-wieczysta-adoracja',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DebicaWieczystaAdoracja' } }],
    },
    {
      meta:
      {
        title: 'Wspólnota NSPJ',
        description: 'Wspólnota Dzieła Intronizacji NSPJ'
      },
      path: '/komorowo-wspolnota-NSPJ',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KomorowoWspolnotaNSPJ' } }],
    },
    {
      meta:
      {
        title: 'Szkoła Parafialna',
        description: 'Informacje nt. szkoły działającej na terenie parafii'
      },
      path: '/denbosch-szkola-parafialna',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'DenboschSzkola' } }],
    },    
    {
      meta:
      {
        title: 'Instytucje dotujące',
        description: 'Instytucje i firmy dotujące remonty kościołów'
      },
      path: '/kotliska-instytucje-dotujace',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KotliskaInstytucjeDotujace' } }],
    },
    {
      meta:
      {
        title: 'Budowa kościoła',
        description: 'Ewidencja prac budowlanych realizowanych w parafii (budowa kościoła)'
      },
      path: '/koszalin-budowa-kosciola',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Renovations/KoszalinRenovationsList.vue') }],
    },
    {
      meta:
      {
        title: 'Budowa kościoła',
        description: 'Opis pojedynczego etapu prac związanych z budową kościoła'
      },
      path: '/koszalin-budowa-kosciola/:id',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Renovations/KoszalinRenovationsDetails.vue') }],
    },
    {
      meta:
      {
        title: 'św. Charbel',
        description: 'Informacje nt. św. Charbel'
      },
      path: '/elblag-swcharbel',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ElblagSwChrabel' } }],
    },
    {
      meta:
      {
        title: 'Pielgrzymki',
        description: 'Pielgrzymki parafialne'
      },
      path: '/elblag-pielgrzymki',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ElblagPielgrzymki' } }],
    },
    {
      meta:
      {
        title: 'Misje',
        description: 'Informacje o misjach'
      },
      path: '/elblag-misje',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ElblagMisje' } }],
    },
    {
      meta:
      {
        title: 'Inwestycje parafialne',
        description: 'Inwestycje parafialne'
      },
      path: '/elblag-inwestycje',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ElblagTrojcyInwestycje' } }],
    },
    {
      meta:
      {
        title: 'Nowenna',
        description: 'Nowenna w parafii'
      },
      path: '/elblag-nowenna',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'ElblagNowenna' } }],
    },
    {
      meta:
      {
        title: 'Budowa kościoła',
        description: 'Budowa kościoła'
      },
      path: '/chojnice-budowa',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'FatimaChojniceBudowaKosciola' } }],
    },
    {
      meta:
      {
        title: 'Wspólnota św. Ojca Pio',
        description: 'Wspólnota św. Ojca Pio'
      },
      path: '/chojnice-pio',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'FatimaChojniceWspolnotaOjcaPio' } }],
    },
    {
      meta:
      {
        title: 'KSM Fatima',
        description: 'KSM Fatima'
      },
      path: '/chojnice-ksm',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'FatimaChojniceKSMFatima' } }],
    },
    {
      meta:
      {
        title: 'Domowy Kościół',
        description: 'Domowy Kościół'
      },
      path: '/chojnice-domowy-kosciol',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'FatimaChojniceDomowyKosciol' } }],
    },
    {
      meta:
      {
        title: 'Logowanie',
        description: 'Logowanie'
      },
      path: '/login',
      component: () => import('pages/Account/Login.vue')
    },
    {
      meta:
      {
        title: 'Informacje o parafii',
        description: 'Podstawowe informacje o parafii'
      },
      path: '/o-parafii',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/ParishInfo/ParishInfo.vue') }],
    },
    {
      meta:
      {
        title: 'Kolorystyka strony',
        description: 'Ustawianie kolorystyki - tematu strony'
      },
      path: '/kolorystyka',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Color/Color.vue') }],
    },
    {
      meta:
      {
        title: 'Nagłowek strony',
        description: 'Ustawianie nagłówka strony'
      },
      path: '/naglowek',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Header/Header.vue') }],
    },
    {
      meta:
      {
        title: 'Abonament',
        description: 'Abonament - informacje o koncie'
      },
      path: '/abonament',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Subscription/Subscription.vue') }],
    },
    {
      meta:
      {
        title: 'Kancelaria parafialna',
        description: 'Kancelaria parafialna'
      },
      path: '/kancelaria',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Office/Office.vue') }],
    },
    {
      meta:
      {
        title: 'Nabożeństwa',
        description: 'Porządek nabożeństw'
      },
      path: '/nabozenstwa',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Devotions/Devotions.vue') }],
    },
    {
      meta:
      {
        title: 'Spowiedź św.',
        description: 'Godziny spowiedzi św.'
      },
      path: '/spowiedz',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Confessions/Confessions.vue') }],
    },
    {
      meta:
      {
        title: 'Facebook parafialny',
        description: 'Parafialny Facebook'
      },
      path: '/facebook',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/Facebook/Facebook.vue') }],
    },
    {
      meta:
      {
        title: 'Dodanie nowej strony',
        description: 'Dodanie nowej własnej strony'
      },
      path: '/dodaj-nowa-strone',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/AddNewPage/AddNewPage.vue') }],
    },
    {
      meta:
      {
        title: 'Grafik katechez',
        description: 'Grafik katechez pozaszkolnych'
      },
      path: '/grafik-katechez',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CatechesisSchedule/CatechesisSchedule.vue') }],
    },
    {
      meta:
      {
        title: 'Obecności na katechezach',
        description: 'Obecności na pozaszkolnych'
      },
      path: '/obecnosci-na-katechezach',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('pages/CatechesisAttendance/CatechesisAttendance.vue') }],
    },
    {
      meta:
      {
        title: 'Błogosławiona Karolina Kózkówna',
        description: 'Informacje nt. Błogosławionej Karoliny Kózkówny'
      },
      path: '/jelowa-bl-karolina',
      component: () => import(`layouts/${layout}/MainLayout.vue`),      
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'JelowaBlKarolina' } }],
    },
    {
      meta:
      {
        title: 'Katolickie Przedszkole bł. Karoliny',
        description: 'Niepubliczne Katolickie Przedszkole bł. Karoliny w Jełowej'
      },
      path: '/jelowa-katolickie-przedszkole',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'JelowaPrzedszkole' } }],
    },
    {
      meta:
      {
        title: 'Modlitwy',
        description: 'Różne modlitwy'
      },
      path: '/lodz-modlitwy',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'LodzodkupicielaModlitwy' } }],
    },
    {
      meta:
      {
        title: 'Ścieżka Jana Pawła II',
        description: 'Ścieżka Jana Pawła II'
      },
      path: '/rajbrot-sciezka',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'RajbrotSciezka' } }],
    },
    {
      meta:
      {
        title: 'Program Europejski',
        description: 'Program Europejski'
      },
      path: '/kozieglowki-program-europejski',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KozieglowkiProgramEuropejski' } }],
    },
    {
      meta:
      {
        title: 'Rewitalizacja kosciola',
        description: 'Informacje nt. prac związanych z rewitalizacją kościoła'
      },
      path: '/kozieglowki-rewitalizacja-kosciola',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KozieglowkiRewitalizacjaKosciola' } }],
    },
    {
      meta:
      {
        title: 'św. Antoni z Padwy',
        description: 'św. Antoni z Padwy'
      },
      path: '/kozieglowki-sw-antoni',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KozieglowkiswAntoni' } }],
    },
    {
      meta:
      {
        title: 'Dla pielgrzymów',
        description: 'Informacje dla pielgrzymów'
      },
      path: '/kozieglowki-dla-pielgrzymow',
      component: () => import(`layouts/${layout}/MainLayout.vue`),
      children: [{ path: '', component: () => import('../components/SimplePlugin.vue'), props: { endpoint: 'KozieglowkiDlaPielgrzymow' } }],
    },


    {
      meta:
      {
        title: 'Błąd 403',
        description: 'Dostęp zabroniony'
      },
      path: '/forbidden',
      component: () => import('pages/Error403.vue'),
    },
    // Always leave this as last one,
    // but you can also remove it
    {
      meta:
      {
        title: 'Błąd 404',
        description: 'Nie istniejąca strona'
      },
      path: '/:catchAll(.*)*',
      component: () => import('pages/Error404.vue'),
    },
  ];
}

export default ecclepRoutesResolver;
